import {
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  HStack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

const Compliance = ({ back, data }) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = (formValues) => {
    const finalData = { ...data, ...formValues };
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing={4}>
        <FormControl>
          <FormLabel>NOC No</FormLabel>
          <Input {...register('noc')} />
        </FormControl>

        <HStack w="100%">
          <Button onClick={back}>Back</Button>
          <Button type="submit" colorScheme="blue">
            Create Company
          </Button>
        </HStack>
      </VStack>
    </form>
  );
};

export default Compliance;
